var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmedCircleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1950 960",
    width: 1950,
    height: 960,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 975 480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1392.2 648.6 A 450 450 0 0 1 557.8 648.6",
    stroke: "#ffffff",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 557.8 311.4 A 450 450 0 0 1 1392.2 311.4",
    stroke: "#ffffff",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 480,
    fill: "#ffffff",
    fontFamily: "'Plus Jakarta Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
    fontSize: 300,
    fontWeight: 800,
    textAnchor: "middle",
    dominantBaseline: "central",
    textLength: 1860,
    lengthAdjust: "spacingAndGlyphs"
  }, "CONFIRMED"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedCircleWhite);
export default __webpack_public_path__ + "static/media/confirmed-circle-white.034e0a1dd7c6ba76cd6460981112ba23.svg";
export { ForwardRef as ReactComponent };